import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommentInterface } from './types/comment.interface';
import { urlCmt } from 'src/app/common';

@Injectable({
  providedIn: 'root'
})
export class CommentsService {

  constructor(private http: HttpClient) { }

  getComments(id: number): Observable<CommentInterface[]> {
    return this.http.get<CommentInterface[]>(`${urlCmt}/get-all/${id}`)
  }

  createComment(data: CommentInterface): Observable<CommentInterface> {
    return this.http.post<CommentInterface>(`${urlCmt}/create`, data)
  }

  updateComment(id: string, data: CommentInterface): Observable<CommentInterface> {
    return this.http.put<CommentInterface>(`${urlCmt}/update/${id}`, data)
  }

  deleteComment(id: string): Observable<{}> {
    return this.http.delete(`${urlCmt}/delete/${id}`)
  }

  getInactiveComments() {
    return this.http.get(`${urlCmt}/get-all-adm`)
  }

  getAllComments4tier1(id: string) {
    return this.http.get(`${urlCmt}/get-all-4tier1/${id}`)
  }

  editCommentStatus(id: string, data: {}) {
    return this.http.put(`${urlCmt}/edit-comment-status/${id}`, data)
  }

  replyCommentAdm(data: {}) {
    return this.http.post(`${urlCmt}/reply`, data)
  }

}
